import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { BRANCHES } from '../data/catalog';
import { scrollToId } from '../services/booking';
import '../styles/Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = (): void => setIsScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const goToTracks = (): void => {
    setIsMenuOpen(false);
    if (location.pathname === '/') {
      scrollToId('tracks');
    } else {
      navigate('/#tracks');
    }
  };

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container header-inner">
        <Link className="wordmark" to="/" aria-label="Bulge Bracket home">
          <img src="/brand/bb-lockup-ink.svg" alt="Bulge Bracket" className="wordmark-img" />
        </Link>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`} aria-label="Primary">
          {BRANCHES.map(branch => (
            <NavLink
              key={branch.id}
              to={`/${branch.id}`}
              className={({ isActive }) => (isActive ? 'nav-link nav-link-active' : 'nav-link')}
            >
              {branch.shortName}
            </NavLink>
          ))}
          <Link className="nav-link" to="/#tutors" onClick={() => setIsMenuOpen(false)}>
            Tutors
          </Link>
          <NavLink
            to="/resources"
            className={({ isActive }) => (isActive ? 'nav-link nav-link-active' : 'nav-link')}
          >
            Resources
          </NavLink>
          <button className="btn btn-primary nav-cta" onClick={goToTracks}>
            Choose your track
          </button>
        </nav>

        <button
          className={`menu-toggle ${isMenuOpen ? 'menu-toggle-open' : ''}`}
          onClick={() => setIsMenuOpen(open => !open)}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default Header;
